import { Observable } from './druid/./druid/Observable';
import { timer as staticTimer } from './druid/./druid/observable/timer';

Observable.timer = staticTimer;

declare module './druid/./druid/Observable' {
  namespace Observable {
    export let timer: typeof staticTimer;
  }
}